export default "__VITE_ASSET__96b31444__"